export default { sha: '2321b0029e2f32e4cd10202e079f42a3efa87bf7', buildNumber: 'undefined' }
